import { interactiveFlatPanel } from "./interactiveFlatPanel";
import { activeLedVideoWall } from "./activeLedVideoWall";
import { vistaDisplayProducts } from "./commercialDisplayVideoWall";

export const products = {
  "Interactive Flat Panel": interactiveFlatPanel,
  "Active LED Video Wall": activeLedVideoWall,
  "Commercial Display": vistaDisplayProducts,
};
